import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess1022KtoBuSperreAutoStatus: 'idle',
    startProcess1022KtoBuSperreAutoError: undefined as any,
    loadUserParamsProcess1022KtoBuSperreAutoStatus: 'idle',
    loadUserParamsProcess1022KtoBuSperreAutoError: undefined as any,

    process1022KtoBuSperreAutoList: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess1022KtoBuSperreAuto = createAsyncThunk('process1022KtoBuSperreAutoSlice/startProcess1022KtoBuSperreAuto', async ({ process1022KtoBuSperreAuto }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess1022KtoBuSperreAuto/`,
        prepareData(process1022KtoBuSperreAuto),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess1022KtoBuSperreAutoStatus } = getState().process1022KtoBuSperreAutoSlice
        return startProcess1022KtoBuSperreAutoStatus !== 'pending'
    }
})

export const loadUserParamsProcess1022KtoBuSperreAuto = createAsyncThunk('process1022KtoBuSperreAutoSlice/loadUserParamsProcess1022KtoBuSperreAuto', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess1022KtoBuSperreAuto/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess1022KtoBuSperreAutoStatus } = getState().process1022KtoBuSperreAutoSlice
        return loadUserParamsProcess1022KtoBuSperreAutoStatus !== 'pending'
    }
})

const Process1022KtoBuSperreAutoSlice = createSlice({
    name: 'process1022KtoBuSperreAutoSlice',
    initialState,
    reducers: {
        resetstartProcess1022KtoBuSperreAuto: (state) => {
            state.job = undefined
            state.startProcess1022KtoBuSperreAutoError = undefined
        },
        resetstartProcess1022KtoBuSperreAutoError: (state) => {
            state.startProcess1022KtoBuSperreAutoError = undefined
        },
        resetloadUserParamsProcess1022KtoBuSperreAuto: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess1022KtoBuSperreAutoError = undefined
        },
        resetloadUserParamsProcess1022KtoBuSperreAutoError: (state) => {
            state.loadUserParamsProcess1022KtoBuSperreAutoError = undefined
        },
        removeFromProcess1022KtoBuSperreAutoListById: (state, action) => {
            state.process1022KtoBuSperreAutoList = state.process1022KtoBuSperreAutoList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess1022KtoBuSperreAutoListByIds: (state, action) => {
            state.process1022KtoBuSperreAutoList = state.process1022KtoBuSperreAutoList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process1022KtoBuSperreAutoList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess1022KtoBuSperreAutoStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process1022KtoBuSperreAutoList = []
            state.startProcess1022KtoBuSperreAutoStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess1022KtoBuSperreAuto.pending, (state) => {
            state.startProcess1022KtoBuSperreAutoStatus = 'pending'
            state.startProcess1022KtoBuSperreAutoError = undefined
        })
        builder.addCase(startProcess1022KtoBuSperreAuto.fulfilled, (state, action) => {
            state.startProcess1022KtoBuSperreAutoStatus = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess1022KtoBuSperreAuto.rejected, (state, action) => {
            state.startProcess1022KtoBuSperreAutoStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess1022KtoBuSperreAutoError = action.error.message
            } else {
                state.startProcess1022KtoBuSperreAutoError = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess1022KtoBuSperreAuto.pending, (state) => {
            state.loadUserParamsProcess1022KtoBuSperreAutoStatus = 'pending'
            state.loadUserParamsProcess1022KtoBuSperreAutoError = undefined
        })
        builder.addCase(loadUserParamsProcess1022KtoBuSperreAuto.fulfilled, (state, action) => {
            state.loadUserParamsProcess1022KtoBuSperreAutoStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess1022KtoBuSperreAuto.rejected, (state, action) => {
            state.loadUserParamsProcess1022KtoBuSperreAutoStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess1022KtoBuSperreAutoError = action.error.message
            } else {
                state.loadUserParamsProcess1022KtoBuSperreAutoError = action.payload
            }
        })

    }
})

export const {
    resetstartProcess1022KtoBuSperreAuto,
    resetstartProcess1022KtoBuSperreAutoError,
    resetloadUserParamsProcess1022KtoBuSperreAuto,
    resetloadUserParamsProcess1022KtoBuSperreAutoError,
    removeFromProcess1022KtoBuSperreAutoListById,
    removeFromProcess1022KtoBuSperreAutoListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process1022KtoBuSperreAutoSlice.actions
export default Process1022KtoBuSperreAutoSlice.reducer
